import 'client-only';

import { atom, useAtom } from 'jotai';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import FLOW_TYPES, {
  type FlowType,
} from '@/services/funnelService/consts/flowType';
import { type PurchaseContext } from '@/types/purchaseContextToggle/types';

import { useNullableProductSelectionAndCheckoutCommonData } from './useProductSelectionAndCheckoutCommonData';

const purchaseContextAtom = atom<undefined | PurchaseContext>(undefined);

const LOCK_PURCHASE_CONTEXT_FLOWS: FlowType[] = [
  FLOW_TYPES.CurologyRetailOneTimeSkin,
];

function getDefaultPurchaseContext(flowType: FlowType): PurchaseContext {
  switch (flowType) {
    case FLOW_TYPES.Resubscription:
    case FLOW_TYPES.ResubscriptionNonExpedited:
      return 'subscription';
    case FLOW_TYPES.CurologyRetailOneTimeSkin:
      return 'onetime';
    default:
      return 'trial';
  }
}

export const usePurchaseContext = () => {
  const { flowType } = useFlowContext();
  let initialPurchaseContext = getDefaultPurchaseContext(flowType);

  // If data is available from the DataProvider, use that as the initial purchase context
  const commonData = useNullableProductSelectionAndCheckoutCommonData();
  if (commonData && !LOCK_PURCHASE_CONTEXT_FLOWS.includes(flowType)) {
    initialPurchaseContext = commonData.initialPurchaseContext;
  }

  const [purchaseContext, setPurchaseContext] = useAtom(purchaseContextAtom);

  return {
    purchaseContext: purchaseContext ?? initialPurchaseContext,
    setPurchaseContext,
  };
};
